import Basepage, { BasePageState } from '../Basepage';

import Parse, { domToReact } from 'html-react-parser';
import {
  browserUrlToReactUrl,
  reactUrlToBrowserUrl,
} from '../../../../urlParse';
import MolLink from '../Basepage/parts/Menu/MolLink';
import React from 'react';

interface ContainerPageState extends BasePageState {}

interface ContainerModel {
  innerHtml: string;
}

export default class ContainerPage extends Basepage<
  ContainerPageState,
  ContainerModel
> {
  renderChild(): JSX.Element {
    /*
    let htmlParserOptions = {
      replace: (domNode: any) => {
        if (domNode.type == 'tag' && domNode.name == 'a') {
          let reactUrl = browserUrlToReactUrl(domNode.attribs.href, null);
          if (reactUrl != '') {
            let molHref = reactUrlToBrowserUrl(reactUrl, null, null);
            if (molHref != '') {
              return (
                <MolLink
                  href={this.state.renderingDomain + molHref}
                  to={reactUrl}
                  title={domNode.attribs.title}
                  children={domToReact(domNode.children, htmlParserOptions)}
                  inlinePadding={true}
                  orgHref={domNode.attribs.href}
                />
              );
            }
          }
        } else if (
          domNode.type == 'tag' &&
          domNode.name == 'div' &&
          domNode.attribs['data-flickity-options'] != undefined
        ) {
        }
      },
      trim: true,
    };
*/
    let htmlBody = '';
    try {
      htmlBody = decodeURIComponent(this.body.innerHtml);
    } catch {}

    const css = `
    #menuStartPoint {
      margin-top: 25px;
    }
`;

    return (
      <div id="ContainerPage">
        <link
          rel="stylesheet"
          type="text/css"
          href="includes/templates/stirling_grand/css/stylesheet.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="includes/templates/stirling_grand/css/stylesheet_css_buttons.css"
        />
        <style type="text/css">{css}</style>
        <span dangerouslySetInnerHTML={{ __html: htmlBody }} />
      </div>
    );
  }

  initState(base: BasePageState): ContainerPageState {
    let newState: ContainerPageState = {
      ...base,
    };

    return newState;
  }

  getApiReqestUrl(): string {
    return this.state.apiBase + this.state.apiData.apiRequestUri;
  }
  childDidMount(): void {}
  childDidUnmount(): void {}
  initJSChild(): string {
    return '';
  }
  childDidUpdate(prevProp: any, prevState: any): void {}
  getRightBreadCrumbParts(): JSX.Element {
    return <></>;
  }
  pageHeaderGetter(): string | null {
    return `
    
    `;
  }
  pageTitleGetter(): string {
    return '';
  }
  getBreadCrumb(): JSX.Element {
    return <span></span>;
  }
  getType(): string {
    return 'ContainerPage';
  }
}
